import {
  GoogleMap,
  DirectionsRenderer,
} from "@react-google-maps/api";
import { useEffect, useState, useRef } from "react";
import styled from "styled-components";
import getCityAndTown from "../../../helper/getCityAndTown";
import { setRoute } from "../../../features/addLoad/addLoadSlice";
import { useDispatch } from "react-redux";

const Container = styled.div`
  width: calc(100% - 420px);
  height: 100vh;

  .map-container {
    width: 100%;
    height: 100%;
  }
`;

const AddLoadMapWideMapSide = ({ route }) => {
  const [map, setMap] = useState(null);
  const [directionsResponse, setDirectionsResponse] = useState(null);
  const [directionsRenderer, setDirectionsRenderer] = useState(null);

  const initialCenter = useRef({ lat: 38.75, lng: 33.75 });
  const initialZoom = useRef(5.5);

  const dispatch = useDispatch();

  const routeOptions = {
    polylineOptions: {
      strokeColor: "#BB2649",
      strokeOpacity: 1.0,
      strokeWeight: 5,
    },
    draggable: true,
  };

  useEffect(() => {
    if (route.length > 1) {
      const origin = { lat: parseFloat(route[0].lat), lng: parseFloat(route[0].lng) };
      const destination = { lat: parseFloat(route[route.length - 1].lat), lng: parseFloat(route[route.length - 1].lng) };
      const waypoints = route.slice(1, route.length - 1).map(item => ({
        location: { lat: parseFloat(item.lat), lng: parseFloat(item.lng) }
      }));

      calculateRoute(origin, destination, waypoints);
    }
  }, [route]);

  const calculateRoute = async (origin, destination, waypoints) => {
    try {
      // eslint-disable-next-line no-undef
      const directionsService = new google.maps.DirectionsService();
      const results = await directionsService.route({
        origin,
        destination,
      // eslint-disable-next-line no-undef
        travelMode: google.maps.TravelMode.DRIVING,
        waypoints: waypoints.length > 0 ? waypoints : null,
        provideRouteAlternatives: true,
      });
      setDirectionsResponse(results);
    } catch (error) {
      console.error("Route calculation error:", error);
    }
  };

  const handleDirectionsChanged = () => {
    if (directionsRenderer) {
      const updatedDirections = directionsRenderer.getDirections();
      const cityTown = updatedDirections.routes[0].legs.map(item => {
        const { currentIl, ilId, currentIlce, ilceOptions, ilceId } = getCityAndTown(item.start_address);
        const lat = item.start_location.lat();
        const lng = item.start_location.lng();
        return { currentIl, ilId, currentIlce, ilceOptions, lat, lng, ilceId };
      });

      const lastLeg = updatedDirections.routes[0].legs[updatedDirections.routes[0].legs.length - 1];
      const { currentIl, ilId, currentIlce, ilceOptions, ilceId } = getCityAndTown(lastLeg.end_address);
      const lastLat = lastLeg.end_location.lat();
      const lastLng = lastLeg.end_location.lng();

      const resultRoutes = [...cityTown, { currentIl, ilId, currentIlce, ilceOptions, lat: lastLat, lng: lastLng, ilceId }];

      const finalRoutes = resultRoutes.map((item, i) => ({
        ...route[i],
        locationData: {
          il: item.currentIl,
          ilce: item.currentIlce,
          lat: item.lat,
          lng: item.lng,
          location: `${item.currentIlce}/${item.currentIl}`,
          ilId: item.ilId,
          ilceId: item.ilceId,
        },
      }));

      dispatch(setRoute(finalRoutes));
    }
  };

  const handleClick = (e) => {
    console.log(e);
  };

  return (
    <Container>
      <GoogleMap
        mapContainerClassName="map-container"
        onClick={handleClick}
        zoom={initialZoom.current}
        center={initialCenter.current}
        onLoad={mapInstance => setMap(mapInstance)}
      >
        {directionsResponse && (
          <DirectionsRenderer
            directions={directionsResponse}
            options={routeOptions}
            onDirectionsChanged={handleDirectionsChanged}
            onLoad={setDirectionsRenderer}
          />
        )}
      </GoogleMap>
    </Container>
  );
};

export default AddLoadMapWideMapSide;